var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var videos = [];
var youTubeInitializedPd = false;

function onYouTubeIframeAPIReady() {
    var numOfVideos = $('.homepage-slider .video-container').length;
    if (numOfVideos < 1)
        return;

    $('.homepage-slider .video-container').each(function (index) {
        var myVideoEl   = $(this).find('.video'),
            myVideoId   = myVideoEl.attr('id'),
            myVideoCode = myVideoEl.data('video-code');
            
            videos[index] = new YT.Player(myVideoId, {
            height: '100%',
            width: '100%',
            host: 'https://www.youtube.com',
            videoId: myVideoCode,
            playerVars: {
                rel: '0',
                controls: '1',
                showinfo: '0',
                autoplay: 0 ,
                mute:1
            },
            events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
            }
        });
        youTubeInitializedPd = true;
    });
    
}

function onPlayerReady(event) {
    event.target.playVideo();
}

function onPlayerStateChange(event) {
    var owl = $(".home-page .homepage-slider > ul").data('owlCarousel');
    owl.stop();

    //when video is finished
    if(event.data === 0) {
        pauseVideo();
        owl.next();
        owl.play();
    }
    //when video is paused
    if(event.data === 2) {
        owl.play();
    }
}

function pauseVideo() {
    for (var i = 0; i < videos.length; i++) {
        if (typeof videos[i].pauseVideo == 'function') {
            videos[i].pauseVideo();
        }
    }

}
function playVideo() {
    for (var i = 0; i < videos.length; i++) {
        if (typeof videos[i].playVideo == 'function') {
            videos[i].playVideo();
        }
    }

}

Vendd.Scripts.load(function () {
    if ($('.home-page .homepage-slider > ul > li').length < 2) return;
    
    var sliderOptions = {
        singleItem: true,
        autoPlay: 5000,
        rewindSpeed: 1500,
        stopOnHover: true,
        autoHeight: true,
        transitionStyle: "fade",
        afterMove: function () {
            if (youTubeInitializedPd){
                var owl = $(".home-page .homepage-slider > ul").data('owlCarousel');
                var activeSlide= $('.home-page .homepage-slider > ul .active');
                var activeVideo= $('.video',activeSlide ).data('video-code');
                pauseVideo();
                    if($('> li',  activeSlide).hasClass("has-video")) {
                        for (var i = 0; i < videos.length; i++) {
                            if (typeof videos[i].playVideo == 'function') {
                                if (activeVideo  == videos[i].playerInfo.videoData.video_id){
                                    videos[i].playVideo();
                                    owl.stop();
                                }
                            }
                        }
                    }
                    else {
                        $(this)[0].options.autoPlay = 5000;
                        owl.play();
                    }
            }
        }
    };
    if ($('.home-page .homepage-slider > ul > .first').hasClass("has-video")){
        sliderOptions.autoPlay=false;
    }
    
    initOwlSlider($('.home-page .homepage-slider > ul'), sliderOptions);

});
